import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import AddBrandPopup from '../Popups/ItemRevision_popup_AddBrand';

const ItemRevision_tab_Brands: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemBrands/ByItem/' + itemId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemBrands/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'brandId', visible: false },
        { title: 'Brand', dataProp: 'brand', dataType: 'brand', sort: 'asc', filterInfo: { filterType: 'Textbox' } }
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.UpdateItem, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemItemBrands'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Brand'
                navigateUrl='/plm/ItemSetup/Brand/'
            />
            {showPopup && <AddBrandPopup itemId={itemId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemRevision_tab_Brands;